<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="notiflogs-page">
    <div class="page-header">
      <div class="page-avatar"><v-icon size="22" color="#fff">mdi-history</v-icon></div>
      <div class="page-header-text">
        <h1 class="page-title">Logi powiadomień</h1>
      </div>
      <span class="count-pill">{{ totalItems }} {{ $t('notificationLogs.entries') }}</span>
    </div>

    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('notificationLogs.searchPlaceholder')"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="channelFilter"
          :items="channelOptions"
          :label="$t('notificationLogs.channel')"
          clearable
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="statusFilter"
          :items="statusOptions"
          :label="$t('common.status')"
          clearable
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn color="primary" block @click="initialize">
          <v-icon left>mdi-refresh</v-icon> {{ $t('notificationLogs.refresh') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="logs"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      item-key="id"
      class="elevation-1 mt-4"
      @click:row="selectLog"
    >
      <template v-slot:item.createdAt="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:item.channel="{ item }">
        <v-chip small :color="getChannelColor(item.channel)" text-color="white">
          <v-icon small left>{{ getChannelIcon(item.channel) }}</v-icon>
          {{ item.channel }}
        </v-chip>
      </template>
      <template v-slot:item.type="{ item }">
        <v-chip small outlined>{{ getTypeLabel(item.type) }}</v-chip>
      </template>
      <template v-slot:item.recipient="{ item }">
        {{ item.recipientEmail || item.recipientPhone || item.recipientId || '-' }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip small :color="getStatusColor(item.status)" text-color="white">
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:item.messageText="{ item }">
        <span class="text-truncate d-inline-block" style="max-width: 300px;">
          {{ item.messageTitle || item.messageText || '-' }}
        </span>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="700">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-email-outline</v-icon>
          {{ $t('notificationLogs.detailTitle') }}
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <tbody>
              <tr><td><strong>{{ $t('common.date') }}</strong></td><td>{{ formatDate(selected.createdAt) }}</td></tr>
              <tr><td><strong>{{ $t('notificationLogs.type') }}</strong></td><td>{{ selected.type }}</td></tr>
              <tr><td><strong>{{ $t('notificationLogs.channel') }}</strong></td><td>{{ selected.channel }}</td></tr>
              <tr><td><strong>{{ $t('notificationLogs.priorityLabel') }}</strong></td><td>{{ selected.priority || '-' }}</td></tr>
              <tr><td><strong>{{ $t('common.status') }}</strong></td><td>
                <v-chip small :color="getStatusColor(selected.status)" text-color="white">{{ selected.status }}</v-chip>
              </td></tr>
              <tr><td><strong>{{ $t('notificationLogs.recipientId') }}</strong></td><td>{{ selected.recipientId || '-' }}</td></tr>
              <tr><td><strong>{{ $t('notificationLogs.phone') }}</strong></td><td>{{ selected.recipientPhone || '-' }}</td></tr>
              <tr><td><strong>{{ $t('notificationLogs.email') }}</strong></td><td>{{ selected.recipientEmail || '-' }}</td></tr>
              <tr><td><strong>{{ $t('notificationLogs.messageTitle') }}</strong></td><td>{{ selected.messageTitle || '-' }}</td></tr>
              <tr><td><strong>{{ $t('notificationLogs.content') }}</strong></td><td>{{ selected.messageText || '-' }}</td></tr>
              <tr v-if="selected.error"><td><strong>{{ $t('notificationLogs.errorLabel') }}</strong></td><td class="red--text">{{ selected.error }}</td></tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">{{ $t('common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'NotificationLogsPage',
  data() {
    return {
      search: "",
      channelFilter: null,
      statusFilter: null,
      options: { page: 1, itemsPerPage: 20 },
      headers: [
        { text: "Data", value: "createdAt", width: "160px" },
        { text: "Kanal", value: "channel", width: "110px" },
        { text: "Typ", value: "type", width: "180px" },
        { text: "Odbiorca", value: "recipient", width: "220px" },
        { text: "Tresc", value: "messageText" },
        { text: "Status", value: "status", width: "100px" },
      ],
      logs: [],
      totalItems: 0,
      loading: false,
      dialog: false,
      selected: {},
      channelOptions: [
        { text: "SMS", value: "SMS" },
        { text: "Email", value: "EMAIL" },
        { text: "In-App", value: "IN_APP" },
      ],
      statusOptions: [
        { text: "Wyslane", value: "SENT" },
        { text: "Mock", value: "MOCK" },
        { text: "Blad", value: "FAILED" },
      ],
    };
  },
  watch: {
    options: { handler() { this.initialize(); }, deep: true },
    search() { this.options.page = 1; this.initialize(); },
    channelFilter() { this.options.page = 1; this.initialize(); },
    statusFilter() { this.options.page = 1; this.initialize(); },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      try {
        const { itemsPerPage, page } = this.options;
        let url = process.env.VUE_APP_ROOT_API +
          `notifications/send-logs?take=${itemsPerPage}&skip=${page}&search=${this.search || ''}`;
        if (this.channelFilter) url += `&channel=${this.channelFilter}`;
        if (this.statusFilter) url += `&status=${this.statusFilter}`;

        const response = await axios({
          method: "get",
          url,
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });
        this.logs = response.data.data.result;
        this.totalItems = response.data.data.count;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    selectLog(log) {
      this.selected = log;
      this.dialog = true;
    },
    formatDate(d) {
      if (!d) return '-';
      return new Date(d).toLocaleString('pl-PL');
    },
    getChannelColor(ch) {
      return { SMS: 'green', EMAIL: 'blue', IN_APP: 'purple' }[ch] || 'grey';
    },
    getChannelIcon(ch) {
      return { SMS: 'mdi-message-text', EMAIL: 'mdi-email', IN_APP: 'mdi-bell' }[ch] || 'mdi-help';
    },
    getStatusColor(s) {
      return { SENT: 'green', MOCK: 'orange', FAILED: 'red' }[s] || 'grey';
    },
    getTypeLabel(type) {
      const labels = {
        'ADMIN_NEW_DRIVER_REGISTRATION': 'Nowa rejestracja',
        'ADMIN_DOCUMENTS_SUBMITTED': 'Dokumenty',
        'ADMIN_NEW_TASK': 'Nowe zgloszenie',
        'ADMIN_TASK_NOTE_FROM_DRIVER': 'Komentarz',
        'ADMIN_DRIVER_CHANGES_REQUEST': 'Zmiana danych',
        'ADMIN_IMPORT_ERROR': 'Blad importu',
        'ADMIN_VEHICLE_INSURANCE_EXPIRING': 'Ubezpieczenie',
        'ADMIN_VEHICLE_INSPECTION_EXPIRING': 'Przeglad',
        'ADMIN_VEHICLE_SERVICE_DUE': 'Serwis',
        'ADMIN_CRASH_REPORTED': 'Szkoda',
        'DRIVER_APPROVED': 'Konto aktywowane',
        'DRIVER_REJECTED': 'Odrzucony',
        'DOCUMENT_VERIFIED': 'Dok. zweryfikowany',
        'DOCUMENT_REJECTED': 'Dok. odrzucony',
        'SETTLEMENT_CREATED': 'Rozliczenie',
        'SETTLEMENT_PAID': 'Wyplata',
        'BONUS_ADDED': 'Bonus',
        'PENALTY_ADDED': 'Kara',
        'TASK_STATUS_CHANGED': 'Status zgloszenia',
        'TASK_NOTE_ADDED': 'Komentarz',
        'DRIVER_PASSWORD_CHANGED': 'Zmiana hasla',
        'DRIVER_ACCOUNT_BLOCKED': 'Konto zablokowane',
        'DRIVER_ACCOUNT_UNBLOCKED': 'Konto odblokowane',
      };
      return labels[type] || type;
    },
  },
};
</script>

<style scoped>
.notiflogs-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { display: flex; align-items: center; gap: 12px; padding: 4px 4px 18px; }
.page-avatar { width: 44px; height: 44px; border-radius: 14px; background: linear-gradient(135deg, #2962FF 0%, #5478FF 100%); display: flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: 0 6px 18px rgba(41,98,255,0.4); }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.count-pill { margin-left: auto; background: rgba(41,98,255,0.18); border: 1px solid rgba(41,98,255,0.35); color: #5478FF; padding: 6px 14px; border-radius: 999px; font-size: 12px; font-weight: 700; }

.notiflogs-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.notiflogs-page >>> .v-text-field--outlined fieldset, .notiflogs-page >>> .v-select--outlined fieldset { border-color: rgba(255,255,255,0.1) !important; }
.notiflogs-page >>> .v-text-field--outlined .v-input__slot, .notiflogs-page >>> .v-select--outlined .v-input__slot { background: #181C28 !important; border-radius: 12px !important; }
.notiflogs-page >>> .v-text-field input, .notiflogs-page >>> .v-select__selection { color: #fff !important; }
.notiflogs-page >>> .v-text-field:not(.v-text-field--outlined) input { color: #fff !important; }
.notiflogs-page >>> .v-text-field:not(.v-text-field--outlined) > .v-input__control > .v-input__slot::before { border-color: rgba(255,255,255,0.16) !important; }
.notiflogs-page >>> .v-label { color: #6E7691 !important; }
.notiflogs-page >>> .v-input__prepend-inner .v-icon, .notiflogs-page >>> .v-input__append-inner .v-icon { color: #6E7691 !important; }
.notiflogs-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.notiflogs-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.notiflogs-page >>> .v-data-table tbody tr { background: #232838 !important; }
.notiflogs-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.notiflogs-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.notiflogs-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.notiflogs-page >>> .v-btn:not(.v-btn--icon) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.notiflogs-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.notiflogs-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.notiflogs-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.notiflogs-page >>> .v-dialog .v-card { background: #232838 !important; }
</style>
